import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div
      style={{
        fontFamily: "'Clash Display', sans-serif",
        backgroundImage: `linear-gradient(45deg, white, rgba(245, 245, 251, 1), rgba(224, 225, 244), rgba(230, 230, 247, 1), rgba(255, 217, 249), rgba(254, 236, 252), white)`,
      }}
      className="min-h-[75vh] flex items-center justify-center px-6 py-24"
    >
      <div className="max-w-md w-full text-center bg-white/80 backdrop-blur-md p-8 md:p-10 rounded-2xl shadow-xl border border-white/60">
        <span className="inline-block rounded-full bg-purple-100 text-primary px-3 py-1 text-xs font-semibold uppercase tracking-wider mb-4">
          Error 404
        </span>
        <h1 className="text-4xl md:text-5xl font-bold text-dark mb-3">
          Page Not Found
        </h1>
        <p
          style={{ fontFamily: "'Montserrat', sans-serif" }}
          className="text-slate-600 text-sm md:text-base leading-relaxed mb-8"
        >
          We couldn&apos;t find the page you were looking for. It may have been moved, renamed, or doesn&apos;t exist.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto rounded-xl bg-primary px-6 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-[#1b1449]"
          >
            Return to Homepage
          </Link>
          <Link
            to="/training"
            className="w-full sm:w-auto rounded-xl border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50"
          >
            Explore Programs
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
